import Vue from 'vue'
// import _ from 'lodash'
import linkifyStr from 'linkifyjs/string'

var Alerts = []
var last_id = 0

var Loading = {
  yes: true
}

Vue.mixin({
  data() {
    return {
      Alerts,
      Loading
    }
  },

  methods: {
    $alert({ trans, type, duration = 5000, dismissible = true }) {
      var id = ++last_id

      if (typeof trans === 'string') {
        trans = {
          text: trans,
          data: {}
        }
      }

      var def = {
        id,
        trans,
        type,
        dismissible
      }

      this.Alerts.push(def)

      if (typeof duration === 'number') {
        setTimeout(() => {
          this.Alerts.splice(this.Alerts.indexOf(def), 1)
        }, duration)
      }
    },

    $handleErrors(e) {
      if (e.response && e.response.status === 422 && typeof e.response.data.error !== 'string') {
        return this.$alert({
          trans: 'errors.validation',
          type: 'danger'
        })
      } else if (e.response && e.response.status === 404) {
        return this.$router.push({name: 'page404'})
      } else if (e.response && e.response.status === 403) {
        if (e.response.data.error) {
          return this.$alert({
            trans: 'errors.' + e.response.data.error,
            type: 'danger'
          })
        } else {
          this.$alert({
            trans: 'errors.forbidden',
            type: 'danger'
          })

          return this.$router.push({name: 'page404'})
        }
      } else if (e.response && e.response.status === 500 && typeof e.response.data.error !== 'string') {
        return this.$alert({
          trans: 'errors.internal',
          type: 'danger'
        })
      } else if (e.response && e.response.data.error) {
        return this.$alert({
          trans: 'errors.' + e.response.data.error,
          type: 'danger'
        })
      } else {
        console && console.error && console.error(e)
      }
    },

    $linkifyStr(str, options) {
      return linkifyStr(str, options)
    }
  }
})



// WEBPACK FOOTER //
// ./src/config/utils.js